import Dexie from 'dexie'
import { CLEAR_SCORE } from '../constants';

const db = new Dexie('ProblemResult');
db.version(1).stores({
    results: "text, phoneme, isSentence, type, score, createdAt"
});

class ProblemResultRepository {

    constructor() {

    }

    getResults() {
        let self = this
        return new Promise((resolve, reject) => {
            db.results.toArray()
                .then((results) => {
                    self.results = results
                    if (results) {
                        resolve(results)
                    } else {
                        reject('no data')
                    }
                })
        })
    }


    getLessonResults(titlePhoneme) {
        return new Promise((resolve, reject) => {
            db.open();
            const results = db.results.where("phoneme").equals(titlePhoneme)
            resolve(results.toArray())
        })
    }


    getSingleScore() {
        db.open();

    }

    updateProblemResult(result) {
        db.open();
        // if (result.score > CLEAR_SCORE) {
        db.results.put({
            text: result.text,
            phoneme: result.targetPhoneme,
            isSentence: result.isSentence,
            type: result.type,
            score: result.score,
            createdAt: new Date()
        });
        // db.close()
        // }
    }
}

const problemResultRepo = new ProblemResultRepository();

export default problemResultRepo;